export const paywallLinkParam = {
	subscription: 'subscription',
	botSubscription: 'bot-subscription',
	neurons: 'neurons',
} as const;
